import React, { memo } from 'react'

import { isPolycountDisabledForSmartLowPoly } from 'Pods/ThreeDStudio/Services/isPolycountDisabledForSmartLowPoly'
import GenericPolyCountSelector from 'Pods/ThreeDStudio/Shared/GenericPolyCountSelector/GenericPolyCountSelector'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setPolyCount, setTargetPolycount } from 'Pods/ThreeDStudio/Store/actions/modelSettings'
import { POLY_COUNT } from 'Pods/ThreeDStudio/Store/constants'

const handleLowClick = (skipSelectedUseCaseUpdate = false) => (
  setPolyCount(POLY_COUNT.LOW, skipSelectedUseCaseUpdate)
)
const handleMediumClick = (skipSelectedUseCaseUpdate = false) => (
  setPolyCount(POLY_COUNT.MEDIUM, skipSelectedUseCaseUpdate)
)
const handleHighClick = (skipSelectedUseCaseUpdate = false) => (
  setPolyCount(POLY_COUNT.HIGH, skipSelectedUseCaseUpdate)
)

function PolyCountSelector() {
  const isSmartLowPoly = useThreeDStudioStore(state => state.modelSettings.isSmartLowPoly)
  // Schema-driven: a provider disables polycount under smart low poly by flagging
  // its polycount key `false` in the `smart_low_poly: true` branch (e.g. tripo3d).
  // Meshy omits that flag, so it keeps polycount editable to drive the low-poly target.
  const polycountDisabled = useThreeDStudioStore(
    state => isPolycountDisabledForSmartLowPoly(state.schema.generationModelSchema),
  )

  const forceDisabled = isSmartLowPoly && polycountDisabled

  return (
    <GenericPolyCountSelector
      handleLowClick={handleLowClick}
      handleMediumClick={handleMediumClick}
      handleHighClick={handleHighClick}
      setTargetPolycount={setTargetPolycount}
      sliceName="modelSettings"
      storeSchemaKey="generationModelSchema"
      forceDisabled={forceDisabled}
    />
  )
}

export default memo(PolyCountSelector)
